export default {
    state:{
        JsonData:{}, //json数据
        keepAlive: ['attentionpage','classify','addarea','servepage'], //缓存页面 keep-alive
        courseJson:{} , // 直播信息json
    },
    mutations:{
        setKeepAlive: (state, keepAlive) => {
            state.keepAlive = keepAlive;
        },
        mutJsonData: (state, val) => {
            state.JsonData = val;
        },
        mutcourseJson: (state, val) => {
            state.courseJson = val;
        },
    },
    actions:{
        keepAlive({commit}, val){//  缓存页面 keep-alive
            commit('setKeepAlive', val)
        },
        actmutJsonData({commit}, val){//  json数据
            commit('mutJsonData', val)
        },
        actmutcourseJson({commit}, val){//  直播信息json
            commit('mutcourseJson', val)
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/control.js